<template>
    <div class="qw-typing">
        <p class="typing">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
        </p>
    </div>
</template>

<script>
export default {
    name: "qw-typing"
}
</script>

<style lang="scss" scoped>
.qw-typing {
    margin: 0;
    padding: 0;
    .typing {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 0;
        padding: 0;
        animation: chatbotTypingAnimation 1s ease infinite;
        .dot {
            display: flex;
            width: 4px;
            height: 4px;
            background-color: $gray;
            border-radius: 50%;
            margin: 0px 2px 0px 0px;
            &:last-child {
                margin: 0;
            }
        }
    }
}
</style>